import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './shared-component/guard/auth/auth.guard';
import { RouterGuardService } from './shared-component/guard/router-guard/router-guard.service';
import { LoanApplicationCustomerTCResolverService } from './shared-component/resolver/loanApplicationCustomerResolver/loan-application-customer-tc-resolver.service';
import { ReferComponent } from './refer/refer.component';


export const routes: Routes = [
  {
    path: 'refer',
    component: ReferComponent
  }, {
    path: 'authentication',
    canActivate: [AuthGuard],
    loadChildren: './authentication/authentication.module#AuthenticationModule'
  // }, {
  //   path: 'loan/process',
  //   loadChildren: './bitly/bitly.module#BitlyModule'
  }, {
    path: 'application',
    canActivate: [AuthGuard],
    loadChildren: './authentication/authentication.module#AuthenticationModule'
  }, {
    path: 'application/mandate',
    loadChildren: './register-enach/register-enach.module#RegisterEnachModule'
  }, {
    path: 'application/esign',
    loadChildren: './register-esign/register-esign.module#RegisterEsignModule'
  }, {
    path: 'concent/bureaucheck',
    loadChildren: './customer-concent/customer-concent.module#CustomerConcentModule'
  }, {
    path: 'tinyurl',
    loadChildren: './tinyurl/tinyurl.module#TinyUrlModule'
  },{
    path: 'error',
    loadChildren: './error/error.module#ErrorModule'
  },{
    path: 'apply',
    loadChildren: './lead-reg/lead-reg.module#LeadRegModule'
  }, {
    path: '',
    component: FullComponent,
    canActivate: [RouterGuardService],
    children: [
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      // { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule' },
      { path: 'dashboard', loadChildren: './loans/loans.module#LoansModule' },
      { path: 'loans', loadChildren: './loans/loans.module#LoansModule' },
      { path: 'applications', loadChildren: './applications/applications.module#ApplicationsModule' },
      { path: 'profile', loadChildren: './profile/profile.module#ProfileModule' }
    ]
  },
  {
    path: '**',
    redirectTo: '404'
  }];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }), NgbModule.forRoot()],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
